export default __webpack_public_path__ + "static/media/background-homepage.6a6e2fa4.jpg";